import React, { useEffect, useState, useCallback } from "react";
import { useParams, Link } from "react-router-dom";
import "./detay.css";

const apiUrl = process.env.REACT_APP_API_BASE_URL;

const BlogDetay = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);

  const fetchBlogDetail = useCallback(async () => {
    try {
      const response = await fetch(`${apiUrl}/api/blogs/${id}`);
      const data = await response.json();
      setBlog(data);
    } catch (error) {
      console.error("Blog detayını getirme hatası:", error);
    }
  }, [id]);

  useEffect(() => {
    fetchBlogDetail();
  }, [fetchBlogDetail]);

  if (!blog) return <div className="text-center mt-5">Yükleniyor...</div>;

  return (
    <div className="container my-5">
      <div className="mb-4">
        <Link to="/blog" className="btn btn-outline-secondary">&larr; Tüm Bloglar</Link>
      </div>

      <h1 className="display-5 fw-bold text-center mb-4" dangerouslySetInnerHTML={{ __html: blog.name }} />

      <div className="text-center mb-3">
        <img
          src={blog.img}
          alt={blog.name}
          className="img-fluid rounded shadow"
          style={{ maxHeight: "400px", objectFit: "cover" }}
        />
        <p className="text-muted mt-2">
          Yayın Tarihi:{" "}
          {new Date(blog.publishedDate).toLocaleDateString("tr-TR", {
            day: "2-digit",
            month: "long",
            year: "numeric",
          })}
        </p>
      </div>

      <div className="blog-description lead mb-4" dangerouslySetInnerHTML={{ __html: blog.description }} />

      <div className="blog-content" dangerouslySetInnerHTML={{ __html: blog.content }} />
    </div>
  );
};

export default BlogDetay;
